exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-wrapper[data-v-59e8f9c8]{margin-top:50px;width:100%}.offset-header[data-v-59e8f9c8]{position:relative;top:-26px!important;margin-inline:auto;max-width:calc(100% - 32px)}.header-card[data-v-59e8f9c8]{margin:0 auto;max-width:calc(100% - 32px);height:52px;color:#fff!important;font-size:24px}.card-header[data-v-59e8f9c8]{transition:all .3s ease-in-out}.headline[data-v-59e8f9c8]{height:100%;flex-wrap:nowrap!important;font-weight:200!important;font-size:24px!important}.card-text[data-v-59e8f9c8]{padding-top:0!important;padding-bottom:0!important}.title[data-v-59e8f9c8]{padding-top:2px}", ""]);

// exports
